import { InferRequestType, InferResponseType } from "hono";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { client } from "@/lib/hono";
import toast from "@/lib/toast";
import { t } from "@/lib/localization";

export type CreatePromptAvatarRequest = InferRequestType<
    (typeof client.api.avatars.heygen.avatars.prompt)["$post"]
>["json"];
export type CreatePromptAvatarResponse = InferResponseType<
    (typeof client.api.avatars.heygen.avatars.prompt)["$post"],
    200
>;

export const useCreatePromptAvatar = () => {
    const qc = useQueryClient();
    return useMutation<
        CreatePromptAvatarResponse,
        Error,
        CreatePromptAvatarRequest
    >({
        mutationKey: ["createPromptAvatar"],
        mutationFn: async (json) => {
            const response = await client.api.avatars.heygen.avatars.prompt.$post({ json });
            if (!response.ok) throw new Error("Failed to create avatar");
            return await response.json();
        },
        onSuccess: () => {
            toast.success(t("avatars.toast.create-prompt.success"), {
                keyName: "avatars.toast.create-prompt.success",
            });
            qc.invalidateQueries({ queryKey: ["avatars"] });
        },
        onError: () => {
            toast.error(t("avatars.toast.create-prompt.error"), {
                keyName: "avatars.toast.create-prompt.error",
            });
        },
    });
};
